import { cn } from '@/lib/utils';

interface DotStepperProps {
  totalSteps: number;
  currentStep: number;
}

/**
 * Simple dot-based progress indicator for the onboarding wizard
 */
export function DotStepper({ totalSteps, currentStep }: DotStepperProps) {
  return (
    <nav aria-label="Progress" className="flex justify-center">
      <ol className="flex items-center gap-2">
        {Array.from({ length: totalSteps }, (_, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;

          return (
            <li key={index}>
              <div
                className={cn(
                  'h-2 w-2 rounded-full transition-colors',
                  isCompleted && 'bg-primary',
                  isCurrent && 'bg-primary',
                  !isCompleted && !isCurrent && 'bg-muted-foreground/30'
                )}
                aria-current={isCurrent ? 'step' : undefined}
              />
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
